/**
 * Keeps htmx's history cache inside the browser's localStorage quota.
 *
 * On a boosted visit htmx saves the page being left to localStorage
 * (htmx-history-cache, the last ten pages) so Back can put it straight back.
 * The quota is about five million characters an origin, shared with every other
 * key we keep. Past it htmx logs htmx:historyCacheError and drops the oldest
 * page; a page bigger than the quota on its own (Home with over a thousand
 * stacks) fails every time and throws the whole cache away trying.
 *
 * - A page too big to keep is left out of the cache: htmx skips saving while
 *   the page holds an hx-history="false" element, so one goes in just before
 *   the swap replaces the page (and it with it). Back then fetches that page
 *   again from the server, as a first visit does.
 * - Before a page goes in, the oldest pages come out until it fits the budget,
 *   so the cache never reaches the quota.
 *
 * Loaded from nav.html and bound on the document, so it holds on every page
 * and across boosted navigation, whether htmx has loaded yet or not.
 */
(function () {
    'use strict';

    if (window._wyldcardsHistoryCacheBudgetInit) return;
    window._wyldcardsHistoryCacheBudgetInit = true;

    var doc = document;
    // Characters of markup. A page past this would crowd out the rest of the cache
    // (and costs a slow save and parse on every visit that follows).
    var PAGE_LIMIT = 1500000;
    // The whole cache, as stored; well under the quota, which other keys share.
    var CACHE_LIMIT = 3000000;

    function historyRoot() {
        return doc.querySelector('[hx-history-elt],[data-hx-history-elt]') || doc.body;
    }

    /* Whether htmx will save the current page before this swap: a boosted visit,
       or a request that pushes or replaces the address. */
    function savesHistory(detail) {
        if (detail.boosted || (detail.requestConfig && detail.requestConfig.boosted)) return true;
        var xhr = detail.xhr;
        if (xhr && (xhr.getResponseHeader('HX-Push-Url') || xhr.getResponseHeader('HX-Replace-Url'))) return true;
        var elt = detail.elt || (detail.requestConfig && detail.requestConfig.elt);
        return !!(elt && elt.closest
            && elt.closest('[hx-push-url],[data-hx-push-url],[hx-replace-url],[data-hx-replace-url]'));
    }

    doc.addEventListener('htmx:beforeSwap', function (e) {
        var detail = e.detail || {};
        if (!detail.shouldSwap || !savesHistory(detail)) return;
        var root = historyRoot();
        if (!root || root.querySelector('[data-history-too-big]')) return;
        if (root.innerHTML.length <= PAGE_LIMIT) return;
        var marker = doc.createElement('template');
        marker.setAttribute('data-hx-history', 'false');
        marker.setAttribute('data-history-too-big', '');
        root.appendChild(marker);
    });

    function stored(entry) {
        try {
            return JSON.stringify(entry).length;
        } catch (err) {
            return 0;
        }
    }

    /* htmx hands over the cache it is about to store, before adding the new page. */
    doc.addEventListener('htmx:historyItemCreated', function (e) {
        var detail = e.detail || {};
        var cache = detail.cache;
        if (!Array.isArray(cache) || !detail.item) return;
        var sizes = cache.map(stored);
        var total = sizes.reduce(function (sum, size) { return sum + size; }, stored(detail.item));
        while (cache.length && total > CACHE_LIMIT) {
            total -= sizes.shift();
            cache.shift();
        }
    });
})();
